// API Base URL Configuration
// Set REACT_APP_API_BASE_URL environment variable to override
// Default: 'https://test.api.fmultratechfarms.com/api' (for test environment)
// For production: 'https://api.fmultratechfarms.com/api'
// For local development: 'http://127.0.0.1:8000/api'
//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api';
//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.fmultratechfarms.com/api';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://test.api.fmultratechfarms.com/api';
// Server Base URL (without /api) – must be the API origin so storage is at e.g. https://api.fmultratechfarms.com/storage/...
export const SERVER_BASE_URL = process.env.REACT_APP_STORAGE_BASE_URL || API_BASE_URL.replace(/\/api\/?$/, '');

// Helper to build full storage URL from a relative path returned by the API.
// Images are served from the API server at /storage/... (e.g. https://api.fmultratechfarms.com/storage/products/xxx).
export const getStorageUrl = (path) => {
  if (!path) return '';
  let p = String(path).trim();

  if (/^https?:\/\//i.test(p)) {
    try {
      p = new URL(p).pathname;
    } catch {
      return path;
    }
  }

  p = p.replace(/^\/+/, '');
  // Strip any leading "api/" so we never build .../api/storage/...
  p = p.replace(/^api\/+/, '');
  if (p && !p.startsWith('storage/')) {
    p = 'storage/' + p;
  }
  const normalizedPath = p ? `/${p}` : '';
  return `${SERVER_BASE_URL}${normalizedPath}`;
};

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

// Generic API request function using fetch
const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const headers = {
    ...getAuthHeaders(),
    ...options.headers,
  };

  // Remove Content-Type for FormData (browser will set it automatically)
  if (options.body instanceof FormData) {
    delete headers['Content-Type'];
  }

  const config = {
    ...options,
    headers,
  };

  try {
    const response = await fetch(url, config);
    
    // Handle 401 Unauthorized
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/admin/login';
      throw new Error('Unauthorized');
    }

    // Parse JSON response
    const data = await response.json();
    
    if (!response.ok) {
      const error = new Error(data.message || 'Request failed');
      error.response = {
        status: response.status,
        data: data,
      };
      throw error;
    }

    return { data, status: response.status, headers: response.headers };
  } catch (error) {
    if (error.response) {
      throw error;
    }
    // Network or other errors
    const networkError = new Error(error.message || 'Network error');
    networkError.response = {
      status: 0,
      data: { message: error.message },
    };
    throw networkError;
  }
};

// API methods
const api = {
  get: (endpoint, config = {}) => {
    return apiRequest(endpoint, {
      method: 'GET',
      ...config,
    });
  },

  post: (endpoint, data, config = {}) => {
    return apiRequest(endpoint, {
      method: 'POST',
      body: data instanceof FormData ? data : JSON.stringify(data),
      ...config,
    });
  },

  put: (endpoint, data, config = {}) => {
    return apiRequest(endpoint, {
      method: 'PUT',
      body: data instanceof FormData ? data : JSON.stringify(data),
      ...config,
    });
  },

  patch: (endpoint, data, config = {}) => {
    return apiRequest(endpoint, {
      method: 'PATCH',
      body: data instanceof FormData ? data : JSON.stringify(data),
      ...config,
    });
  },

  delete: (endpoint, config = {}) => {
    return apiRequest(endpoint, {
      method: 'DELETE',
      ...config,
    });
  },
};

// Generic authenticated request function
export const authenticatedRequest = async (url, options = {}) => {
  return apiRequest(url, options);
};

export default api;
